import { reject } from "lodash";

import { URL_PREFIX } from "./const";
import featureToggles from "../../config/feature-toggles.malaysia";
export const NECESSARY_STEPS = [
  "listingDetails",
  "location",
  "propertyDetails",
  "descriptionAndMedia",
];

export type StepInfo = {
  index: number;
  name: string;
  isLast?: boolean;
  isFirst?: boolean;
};

export const STEP_NAMES = {
  listingDetails: "Listing details",
  location: "Location",
  propertyDetails: "Property Details",
  descriptionAndMedia: "Description & Media",
  upgradeAndReview: "Upgrade & Publish",
  upgrade: "Upgrade",
};

export type StepType = {
  path: string;
  name: string;
  gaLabel: string;
  isInvalid?: boolean;
  buttonNext?: string;
  buttonBack?: string;
  buttonSave?: string;
};

export const steps: StepType[] = [
  {
    name: "listingDetails",
    gaLabel: STEP_NAMES.listingDetails,
    path: URL_PREFIX + "/add-listing/listing-details",
    buttonBack: "cancel",
  },
  {
    name: "location",
    gaLabel: STEP_NAMES.location,
    path: URL_PREFIX + "/add-listing/location",
  },
  {
    name: "propertyDetails",
    gaLabel: STEP_NAMES.propertyDetails,
    path: URL_PREFIX + "/add-listing/property-details",
  },
  {
    name: "descriptionAndMedia",
    gaLabel: STEP_NAMES.descriptionAndMedia,
    path: URL_PREFIX + "/add-listing/description-and-media",
  },
  {
    name: "upgradeAndReview",
    gaLabel: STEP_NAMES.upgradeAndReview,
    path: URL_PREFIX + "/add-listing/upgrade-and-review",
    buttonNext: "publish",
  },
];

export const stepsV2: StepType[] = [
  {
    name: "locationV2",
    gaLabel: STEP_NAMES.location,
    path: URL_PREFIX + "/add-listing/location",
    buttonBack: "cancel",
  },
  {
    name: "propertyDetailsV2",
    gaLabel: STEP_NAMES.propertyDetails,
    path: URL_PREFIX + "/add-listing/property-details",
  },
  {
    name: "descriptionAndMedia",
    gaLabel: STEP_NAMES.descriptionAndMedia,
    path: URL_PREFIX + "/add-listing/description-and-media",
  },
  {
    name: "upgradeAndReview",
    gaLabel: STEP_NAMES.upgradeAndReview,
    path: URL_PREFIX + "/add-listing/upgrade-and-review",
    buttonNext: "publish",
  },
];

export const getSteps = (unnecessarySteps?: string[]): StepType[] => {
  let availableSteps: StepType[];
  if (featureToggles.LSOT) {
    availableSteps = stepsV2;
  } else {
    availableSteps = steps;
  }

  if (unnecessarySteps) {
    const rejectPredecates = (step: StepType) =>
      unnecessarySteps.indexOf(step.name) !== -1;
    return reject(availableSteps, rejectPredecates);
  }

  return availableSteps;
};
